import { BUSCAR_ITINERARIOS_FUTURO, ALTERAR_ITINERARIO_FUTURO } from '../../actions/types'

const initialState = {
  itinerarios: [],
  total: 0
}

export default function reducerBuscarItinerariosFuturo(state = initialState, action = initialState) {
  switch (action.type) {
    case BUSCAR_ITINERARIOS_FUTURO: {
      let agrupador = action.payload.data;

      if (agrupador.itinerarios) {
        let total = agrupador.total
        let itinerarios = agrupador.itinerarios.map(itinerario => Object.assign({}, itinerario, { selecionado: false }))
          .sort((a, b) => new Date(a.data) - new Date(b.data));
        return {
          ...state,
          itinerarios,
          total
        }
      }
      return state
    }

    case ALTERAR_ITINERARIO_FUTURO: {
      const itinerario = action.payload;
      const indice = state.itinerarios.indexOf(itinerario);
      const novoItinerario = Object.assign({}, itinerario, { selecionado: !itinerario.selecionado });
      let itinerarios = Object.assign([], state.itinerarios);
      itinerarios = itinerarios.map(it => Object.assign({}, it, { selecionado: false }));
      itinerarios[indice] = novoItinerario;
      return {
        ...state,
        itinerarios
      }
    }

    default: {
      return state
    }
  }
}
